import Text from "lib/core/components/text/Text"

const Completion = function ({ content, step }) {
  const { method, task } = content
  return (
    <div className="Content__Completion Content--padded">
      {(() => {
        switch (method) {
          case "task":
            return (
              <Text
                html={task}
                interceptLink={true}
                katex={true}
                theme={true}
              />
            )
        }
      })()}
    </div>
  )
}

Completion.displayName = "Completion"

export default Completion
